import { Component, OnInit, OnDestroy } from '@angular/core';
import { finalize, first, takeUntil } from 'rxjs/operators';
import { AppSettings } from '@app/app.settings';

import { Kb } from '@models';
import { ServicePreferences } from '@services';
import { Subject } from 'rxjs';

@Component({
    selector: 'preferences-default-listing-view-on-item',
    templateUrl: './preferences-default-listing-view-on-item.component.html',
    styleUrls: ['./preferences-default-listing-view-on-item.component.scss']
})
export class PreferencesDefaultListingViewOnItemComponent implements OnInit, OnDestroy {

    public saving = false;
    public availableDefaultListingViewsOnItem: string[] = [
        'TABLE',
        'TILES',
        'MAP',
        'SUMMARY'
    ];
    public currentUserDefaultListingViewOnItem: string;

    private _destroyed$ = new Subject();

    constructor(
        private appSettings: AppSettings,
        private servicePreferences: ServicePreferences
    ) {
    }

    ngOnInit() {
        this.currentUserDefaultListingViewOnItem = this.servicePreferences.getPreference('defaultListingViewOnItem');
    }

    ngOnDestroy() {
        this._destroyed$.next();
        this._destroyed$.complete();
        this._destroyed$.unsubscribe();
    }

    trackValues(index: number, o: string) {
        return o ? o : index;
    }

    changeDefaultListingViewsOnItem($event) {
        this.appSettings.settings.defaultListingViewOnItem = $event.value;

        this.saving = true;
        this.servicePreferences.savePreference({ 'defaultListingViewOnItem': $event.value }).pipe(
            finalize(() => {
                this.saving = false;
            }),
            first(),
            takeUntil(this._destroyed$)
        ).subscribe();
    }
}
